export default "__VITE_PUBLIC_ASSET__191d0c25__"